export { default } from './Modal';
export { default as ModalManager } from './ModalManager';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Modal/index.js
// module id = 185
// module chunks = 0